module.exports = __webpack_public_path__ + "img/xrp.0833ca2f.svg";